import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface MultiFacetCountsFromAlgoliaParams {
  org_id: string;
  facet_filters?: (string | string[])[];
  assigned_to?: string;
  facet_attributes?: string[];
  max_values?: number;
  created_at_start?: string;
  created_at_end?: string;
  date_of_service_start?: string;
  date_of_service_end?: string;
  date_of_work_start?: string;
  date_of_work_end?: string;
}

export interface MultiFacetCountsFromAlgoliaResponse {
  facet_results: {
    [key: string]: {
      [key: string]: number;
    };
  };
  facet_attribute: string;
  org_id: string;
  assigned_to?: string;
  success?: boolean;
  message?: string;
  total_count?: number;
}

export const multiFacetCountsFromAlgolia = async (
  params: MultiFacetCountsFromAlgoliaParams,
): Promise<MultiFacetCountsFromAlgoliaResponse> => {
  const bearerToken = await getBearerToken();

  const raw = JSON.stringify(params);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    body: raw,
  };

  try {
    const response = await fetch(
      API_ENDPOINTS.ALGOLIA_MULTI_FACET_COUNTS,
      requestOptions,
    );
    const result = await response.json();
    return result as MultiFacetCountsFromAlgoliaResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
